<template>
  <AppView :title="title" :backable="true">
    <div class="px-2">
      <h1 class="text-lg font-bold text-center mt-4">{{ title }}</h1>
      <div class="tracking-wider">
        <div
          class="text-sm text-chicago mb-1 whitespace-pre-wrap tracking-widest leading-5"
          v-html="rules"
        />
      </div>
    </div>
  </AppView>
</template>

<script>
const path = "teams/policies/privacy";
import { mapGetters } from "vuex";
export default {
  auth: false,
  head() {
    const info = this.$store.getters["app/info"];
    const imgs = this.$store.getters["app/imgs"];
    const privacy = info.docs.privacy;
    const title = privacy.title;
    const content = privacy.content;
    return {
      title: `${info.name}-${title}`,
      meta: [
        {
          hid: "keywords",
          name: "keywords",
          content: `${info.name},${info.name}${title}`,
        },
        {
          hid: "description",
          name: "description",
          content: content,
        },
        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: `${info.name}-${title}`,
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          property: "og:site_name",
          content: `${info.name}`,
        },
        {
          hid: "og:url",
          name: "og:url",
          property: "og:url",
          content: `${process.env.APP_URL}/${path}`,
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: content,
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content: imgs.logo,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      info: "app/info",
    }),
    title() {
      return this.info.docs.privacy.title;
    },
    rules() {
      return this.info.docs.privacy.content;
    },
  },
};
</script>

<style lang="scss" scoped></style>
